module.exports = __webpack_public_path__ + "static/media/business_verification.8488509c.png";